export enum ViewTypes {
  GROUP = "GROUP",
  USER = "USER",
  ROLE = "ROLE",
  ORGANISATION = "ORGANISATION"
}
